import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouteData } from 'react-static';
import Cookies from 'js-cookie';
import CampaignBanner from './CampaignBanner';
import { getActiveBanners, getBannerText } from './campaignBannerConfig';
import { AB_COOKIE } from '../../../constants';

const ResponsiveBannerText = ({ text }) => (
  <React.Fragment>
    <span className="titleMini">{text.mini}</span>
    <span className="titleSmall">{text.small}</span>
    <span className="titleMedium">{text.medium}</span>
  </React.Fragment>
);

ResponsiveBannerText.propTypes = {
  text: PropTypes.shape({
    mini: PropTypes.string.isRequired,
    small: PropTypes.string.isRequired,
    medium: PropTypes.string.isRequired,
  }).isRequired,
};

const getAbCookie = () => {
  const cookie = Cookies.get(AB_COOKIE);
  return cookie ? JSON.parse(cookie) : {};
};
class FilteredCampaignBannerList extends Component {
  static propTypes = {
    basename: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.abCookie = typeof window !== 'undefined' ? getAbCookie() : null;
  }

  render() {
    if (!this.abCookie) return null;

    const banners = getActiveBanners(this.props.basename, this.abCookie);

    if (!banners.length) {
      return null;
    }

    return banners.map(banner => (
      <CampaignBanner
        key={banner.id}
        campaignPath={banner.campaignPath}
        displayOnce={banner.displayOnce}
      >
        <ResponsiveBannerText text={getBannerText(banner)} />
      </CampaignBanner>
    ));
  }
}

export default withRouteData(FilteredCampaignBannerList);



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/main/header/FilteredCampaignBannerList.js